var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.31143 0L6.31143 12.6743","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M11.6267 7.41406L6.31187 12.7289L1.00006 7.41406","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

ArrowDown.defaultProps = {"width":"13","height":"15","viewBox":"0 0 13 15","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
